import { TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN } from "../config/constants";

export const crossroad1CBlue1ARedShow = tracksData => {
	const track1ARed = tracksData['Track1ARed'];
	const track1CBlue = tracksData['Track1CBlue'];

	if (!track1ARed || !track1CBlue) return false;

	return track1ARed.status !== track1CBlue.status;
};

export const crossroad2CBlue2BRed = tracksData => crossroadCondition(tracksData, ['2CBlue', '2BRed']);
export const crossroad5KBlue5CRed = tracksData => crossroadCondition(tracksData, ['5KBlue', '5CRed']);
export const crossroad5ABlue5DRed = tracksData => crossroadCondition(tracksData, ['5ABlue', '5DRed']);

export const crossroad5CRedFBlueGBlue5BBlue5ABlue = tracksData => {
	console.log('update crossroad conditions');
	return crossroadCondition(
		tracksData,
		['5CRed', 'FBlue', 'GBlue', '5BBlue', '5ABlue']
	);
};

export const crossroad8CRed8DBlue = tracksData => crossroadCondition(tracksData, ['8CRed', '8DBlue']);
export const crossroad8BRed8DBlue8CRed = tracksData => {
	let { statusDifferent, status } = crossroadCondition(tracksData, ['8CRed', '8DBlue'], true);

	const track8C = tracksData['Track8CRed'];
	const track8D = tracksData['Track8DBlue'];
	const track8B = tracksData['Track8BRed'];

	if (!track8C || !track8D || !track8B) return false;

	if (statusDifferent) {
		if (track8C.status === TRACK_STATUS_OPEN && track8D.status === TRACK_STATUS_OPEN) {
			return track8B.status !== status;
		} else {
			return track8B.status === TRACK_STATUS_CLOSED;
		}
	} else {
		if (status === TRACK_STATUS_OPEN) {
			return track8B.status === TRACK_STATUS_CLOSED;
		} else {
			return track8B.status === TRACK_STATUS_OPEN;
		}
	}
};

export const crossroad12ARed12DRed = tracksData => crossroadCondition(tracksData, ['12ARed', '12DRed']);
export const crossroad12CRed12DRed = tracksData => crossroadCondition(tracksData, ['12CRed', '12DRed']);
export const crossroad12BBlue12DRed = tracksData => crossroadCondition(tracksData, ['12BBlue', '12DRed']);
export const crossroad11DRed11CBlack = tracksData => crossroadCondition(tracksData, ['11DRed', '11CBlack']);
export const crossroad11FBlue11CBlack = tracksData => crossroadCondition(tracksData, ['11FBlue', '11CBlack']);
export const crossroad11FBlue11DRed = tracksData => crossroadCondition(tracksData, ['11FBlue', '11DRed']);
export const crossroad11FBlue11ARed = tracksData => crossroadCondition(tracksData, ['11FBlue', '11ARed']);
export const crossroad11DRed11FBlue = tracksData => crossroadCondition(tracksData, ['11DRed', '11FBlue', '11ERed']);
export const crossroad11BBlack11BBlack = tracksData => crossroadCondition(tracksData, ['11BBlack', '11FBlue']);
export const crossroad16DBlack16CBlack = tracksData => crossroadCondition(tracksData, ['16DBlack', '16CBlack']);
export const crossroad16ARed16CBlack = tracksData => {
	const track16ARed = tracksData['Track16ARed'];
	const track16BBlack = tracksData['Track16BBlack'];
	const track16CBlack = tracksData['Track16CBlack'];

	if (!track16ARed || !track16BBlack || !track16CBlack) return false;

	const track16ARedIsOpen = track16ARed.status === TRACK_STATUS_OPEN;
	const track16BBlackIsOpen = track16BBlack.status === TRACK_STATUS_OPEN;
	const track16CBlackIsOpen = track16CBlack.status === TRACK_STATUS_OPEN;

	if (track16ARedIsOpen && !track16CBlackIsOpen && !track16BBlackIsOpen)
		return true;

	if (!track16ARedIsOpen && track16CBlackIsOpen && track16BBlackIsOpen)
		return false;

	const tracksToCompare = ['16CBlack', '16BBlack'];
	if (!track16ARedIsOpen) {
		tracksToCompare.push('16ARed');
	}

	const needToShow = crossroadCondition(tracksData, tracksToCompare);
	return (needToShow && track16ARedIsOpen && track16CBlackIsOpen) ? false : needToShow;
};

export const crossroad16ARed16BBlack = tracksData => crossroadCondition(tracksData, ['16ARed', '16BBlack']);
export const crossroad14BBlue14ABlue = tracksData => crossroadCondition(tracksData, ['14BBlue', '14ABlue']);
export const crossroad15EBlue15DRedSBlue = tracksData => crossroadCondition(tracksData, ['15EBlue', '15DRed', 'SBlue']);
export const crossroad15DRed14BBlue = tracksData => crossroadCondition(tracksData, ['15DRed', '14BBlue']);
export const crossroad14ABlue22ABlack = tracksData => crossroadCondition(tracksData, ['14ABlue', '22ABlack']);
export const crossroad14ABlueSBlue = tracksData => crossroadCondition(tracksData, ['14ABlue', 'SBlue']);
export const crossroad5KBlue5GRed5FBlack = tracksData => crossroadCondition(tracksData, ['5KBlue', '5GRed', '5FBlack']);
export const crossroad5KBlue5EBlack = tracksData => crossroadCondition(tracksData, ['5KBlue', '5EBlack', '5GRed']);
export const crossroadJBlue13EBlue = tracksData => crossroadCondition(tracksData, ['JBlue', '13EBlue']);
export const crossroad13ARed13CRed = tracksData => {
	const track13ARed = tracksData['Track13ARed'];
	const track13BRed = tracksData['Track13BRed'];
	const track13CRed = tracksData['Track13CRed'];

	if (!track13ARed || !track13BRed || !track13CRed) return false;

	const needToShow = crossroadCondition(tracksData, ['13ARed', '13BRed', '13CRed']);
	const isTrack13ARedOpen = track13ARed.status === TRACK_STATUS_OPEN;
	const isTrack13BRedOpen = track13BRed.status === TRACK_STATUS_OPEN;
	const isTrack13CRedOpen = track13CRed.status === TRACK_STATUS_OPEN;

	if (isTrack13CRedOpen) {
		return (isTrack13ARedOpen || isTrack13BRedOpen) ? false : needToShow;
	} else {
		return (isTrack13ARedOpen && isTrack13BRedOpen) ? true : needToShow;
	}
};

export const crossroad13ARed13BRed = tracksData => crossroadCondition(tracksData, ['13ARed', '13BRed']);
export const crossroad9ABlue13CRed = tracksData => crossroadCondition(tracksData, ['9ABlue', '13CRed']);

export const crossroad9ABlue13BRed = tracksData => {
	const track9ABlue = tracksData['Track9ABlue'];
	const track13BRed = tracksData['Track13BRed'];
	const track13CRed = tracksData['Track13CRed'];

	if (!track9ABlue || !track13BRed || !track13CRed) return false;

	const needToShow = crossroadCondition(tracksData, ['9ABlue', '13BRed', '13CRed']);
	const isTrack9ABlueOpen = track9ABlue.status === TRACK_STATUS_OPEN;
	const isTrack13BRedOpen = track13BRed.status === TRACK_STATUS_OPEN;
	const isTrack13CRedOpen = track13CRed.status === TRACK_STATUS_OPEN;

	if (isTrack9ABlueOpen) {
		return (isTrack13CRedOpen || isTrack13BRedOpen) ? false : needToShow;
	} else {
		if (isTrack13CRedOpen && isTrack13BRedOpen) {
			return false;
		}

		return needToShow;
	}
};

export const crossRoad1CBlue1BBlack1EBlue = tracksData => {
	const track1EBlue = tracksData['Track1EBlue'];
	const track1BBlack = tracksData['Track1BBlack'];
	const track1CBlue = tracksData['Track1CBlue'];
	const track1ARed = tracksData['Track1ARed'];

	if (!track1EBlue || !track1BBlack || !track1CBlue || !track1ARed) return false;

	let needToShow = crossroadCondition(tracksData, ['1EBlue', '1BBlack']);
	const isTrack1CBlueOpen = track1CBlue.status === TRACK_STATUS_OPEN;
	const isTrack1ARedOpen = track1ARed.status === TRACK_STATUS_OPEN;
	const isTrack1EBlueOpen = track1EBlue.status === TRACK_STATUS_OPEN;

	if (!needToShow) {
		if (isTrack1EBlueOpen) {
			if (isTrack1CBlueOpen || isTrack1ARedOpen) {
				needToShow = false;
			}

			if (!isTrack1CBlueOpen && !isTrack1ARedOpen) {
				needToShow = true;
			}
		} else {
			if (isTrack1CBlueOpen || isTrack1ARedOpen) {
				needToShow = true;
			}
		}
	}

	return needToShow;
};

export const crossRoad2CBlue2BRed = tracksData => crossroadCondition(tracksData, ['2CBlue', '2BRed']);

/** =========================================================================================== */
export const crossroadCondition = (tracksData, tracksNamesArray, returnStatuses, dependOnTrackId) => {
	const firstTrackKey = 'Track' + tracksNamesArray[0];
	if (tracksData && tracksData[firstTrackKey]) {
		let status = tracksData[firstTrackKey].status;
		let statusDifferent = false;

		tracksNamesArray.forEach(key => {
			const trackKey = 'Track' + key;
			if (tracksData[trackKey]) {
				if (status !== tracksData[trackKey].status) {
					status = tracksData[trackKey].status;
					statusDifferent = true;
				}
			}
		});

		if (dependOnTrackId && tracksData['Track' + dependOnTrackId]) {
			statusDifferent = tracksData['Track' + dependOnTrackId].status !== status;
		}

		if (returnStatuses)
			return { statusDifferent, status };

		return statusDifferent;
	}

	return returnStatuses ? { statusDifferent: false, status: TRACK_STATUS_CLOSED } : false;
};

export const connectorCondition = tracks => {
	let statusChanged = false;
	let status = TRACK_STATUS_CLOSED;

	tracks.forEach(track => {
		if (typeof track !== 'undefined' && track?.status !== status && !statusChanged) {
			statusChanged = true;
			status = track?.status;
		}
	});

	return status;
};

export const getConnectorTracksDepends = (stringsArray, tracks) => stringsArray.map(trackString => tracks['Track' + trackString]);
